<template>
  <!-- tezge sa kuponom na pocetnoj: logika klizaca je u ScrollSlider -->
  <ScrollSlider
    :items="filteredProducts"
    :title="title"
    :item-key="(product, index) => (product?.id ?? index) + '-seo'"
    item-class="swiper-product-width tzc-slide"
    :btn-prev-class="['swiper-button-prev-tc-most', btn_prev]"
    :btn-next-class="['swiper-button-next-tc-most', btn_next]"
    :dots-class="['mt-5 swiper-pagination-most', paginate]"
  >
    <template #item="{ item }">
      <ProductDisplayAd :product="item" :title-tag="itemTitleTag" />
    </template>
  </ScrollSlider>
</template>

<script setup>
import ScrollSlider from '~/components/widgets/Slider/ScrollSlider.vue'
import ProductDisplayAd from './ProductsDisplayAd.vue'

const props = defineProps({
  products: { type: Array, default: () => [] },
  // oznaka naslova svakog oglasa u traci ("div" ili "h3"/"h4")
  itemTitleTag: { type: String, default: 'div' },
  from: { type: Number, default: 0 },
  to: { type: Number, default: 10 },
  type: { type: String, default: '' },
  title: { type: String, default: '' },

  paginate: { type: String, default: 'swiper-pagination' },
  btn_next: { type: String, default: 'swiper-button-next-tc-top' },
  btn_prev: { type: String, default: 'swiper-button-prev-tc-top' }
})

// samo top oglasi tezgi, najvise 8, pa from/to
const filteredProducts = computed(() => {
  if (!Array.isArray(props.products)) return []
  const filtered = props.products.filter((x) => x?.lawyer == 1 && x?.top_ad == 1 && x?.top_category == 0).slice(0, 8)
  return filtered.slice(props.from, props.to)
})
</script>
